import { forwardRef } from 'react'

import {
  TextButtonStyled,
  type ITextButtonStyledProps,
} from './styles/TextButtonStyled'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export interface ITextButtonProps extends ITextButtonStyledProps {}

export const TextButton = forwardRef<HTMLButtonElement, ITextButtonProps>(
  ({ analyticsId, ...otherProps }, ref) => (
    <TextButtonStyled
      ref={ref}
      {...getAnalyticsDataAttrs(analyticsId)}
      {...otherProps}
    />
  )
)

TextButton.displayName = 'TextButton'
